<template>
  <v-container id="lineup" fluid>
    <h1 class="primary--text mt-3">
      Speaker
    </h1>

    <v-layout row wrap>
      <template v-for="(item, index) in items">
        <v-flex :key="index" xs12 md6>
          <v-card
            :id="item.id"
            color="white"
            class="mt-4"
            :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }"
          >
            <v-img
              :src="require('../assets/images/speaker/' + item.image)"
              contain
            />

            <v-card-title>
              <h3 class="headline my-3">{{ item.title }}</h3>
              <div v-html="item.text" />
            </v-card-title>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      items: [
        {
          id: 'tom-alby',
          title: 'Tom Alby',
          text: '<p>Als Chief Digital Transformation Officer ist Tom Alby bei Euler Hermes für Deutschland, Österreich und die Schweiz verantwortlich. Der 46-Jährige baut seit dem 1. November ein Digital Transformation Team auf, das für die Koordination digitaler Projekte und die kulturelle Begleitung des digitalen Wandels im Unternehmen verantwortlich ist.</p><p><strong>25 Jahre online: Von Google bis Interone mit Datenanalyse und künstlicher Intelligenz</strong><br>Tom Alby ist seit 25 Jahren online und kommt von der Digitalagentur Interone, die zum Agentur-Netzwerk BBDO Germany gehört. Dort war er seit Anfang 2017 als Director Data and Analytics für das Thema Datenanalyse sowie insbesondere datengetriebene Entscheidungen und Geschäftsmodelle zuständig. Zudem war er Leiter der Data Academy bei BBDO.</p><p>Tom Alby verbrachte zudem fünf Jahre seiner Karriere bei Google Deutschland, wo er als Sales Lead Enterprise Analytics für den Vertrieb der Datenanalyse-Tools von Google in der DACH-Region sowie Mittel- und Osteuropa verantwortlich war.</p><p>Er ist mehrfacher Buchautor und verfasste Fachbücher über das Web 2.0, über professionelles Blogging sowie über das Mobile Web. Er hat einen Lehrauftrag für Datenanalyse an der Hamburger Hochschule für Angewandte Wissenschaften in Hamburg.</p>',
          image: 'tom-alby.jpg',
          link: 'https://eulerhermes.de'
        },
        {
          id: 'karl-kratz',
          title: 'Karl Kratz',
          text: '<p>Karl Kratz liebt und lebt feines Online-Marketing seit 1996.</p>',
          image: 'karl-kratz.jpg',
          link: 'https://karlkratz.de/onlinemarketing-blog/'
        },
        {
          id: 'sarah-weitnauer',
          title: 'Sarah Weitnauer',
          text: '<p>Sarah Weitnauer führt die Agentur PSYKETING in Salzburg. Die studierte Psychologin und Diplom Online Marketerin beschäftigt sich seit 2004 mit Marketing und verknüpft dieses mit diversen Disziplinen der Psychologie. Sie erarbeitet psychologische Strategien zur Conversionoptimierung und berät Websitenbetreiber und Agenturen im gesamten DACH Raum.</p>',
          image: 'sarah-weitnauer.jpg',
          link: 'https://psyketing.de'
        },
        {
          id: 'sven-deutschländer',
          title: 'Sven Deutschländer',
          text: '<p>Sven Deutschländer ist Geschäftsführer der Berliner Marketing-Agentur dskom GmbH. Seit 2002 unterstützt er Unternehmen beim Auf- und Ausbau von deren Online-Sichtbarkeit. Als „SEO Profi Berlin“ stellt er Beratung und Seminare zu den wichtigsten Online-Marketing-Themen in den Fokus. Neben seiner „SEO Profi Akademie“ liegen ihm seine „Fünf Sterne Online-Marketing“-Events sehr am Herzen.</p>',
          image: 'sven-deutschlaender.jpg',
          link: 'https://www.seo-profi-berlin.de'
        },
        {
          id: 'christiane-sohn',
          title: 'Christiane Sohn',
          text: '<p>Christiane Sohn ist leidenschaftliche (Online-) Texterin. Die gelernte Wirtschafts-Redakteurin beschäftigt sich seit mehr als 20 Jahren mit Schreiben, Worten, Sprache. Ihr Herzensthema ist achtsame Kommunikation. Sie verfasst Texte für Online-Seiten, Magazine und den eigenen Blog, trainiert Firmen und Selbstständige hinsichtlich Schreiben allgemein und Online-Inhalte im Speziellen, gibt Workshops live und online. Die Journalistin ist bekannt für ihre emotionalen, leserorientierten Texte.</p>',
          image: 'christiane-sohn.jpg',
          link: 'https://christiane-sohn.de'
        },
        {
          id: 'annelie-baensch',
          title: 'Annelie Bänsch',
          text: '<p>Die 34 Jährige Greifswalderin Annelie ist Mutter, Influencerin und Bloggerin aus Leidenschaft. Nach diversen Blogs zu den Themen Mutter-sein, Nähen, Heimat und Reisen, gehört Annelie heute zu den bekanntesten Influencerinnen aus dem Raum Vorpommern.</p><p>Neben ihren beruflichen Stationen im Marketing und Social Media Bereich von Unternehmen in der Modebranche, sowie in der Eventgastronomie, berät und unterstützt sie seit Jahren mit ihrem Unternehmen vonAhoi eine Vielzahl von Firmen und öffentlichen Einrichtungen im Bereich Social Media.</p>',
          image: 'annelie-baensch.jpg',
          link: 'https://www.instagram.com/annelievonahoi/'
        },
        {
          id: 'katja-wolter',
          title: 'Katja Wolter',
          text: '<p>Katja Wolter leitet seit 2013 das Steinbeis-Forschungszentrum – Institut für Ressourcen-Entwicklung in Greifswald. Sie berät Organisationen zur Strategie- und Teamentwicklung. Sie ist Dozentin an verschiedenen Universitäten und unterstützt unter anderem Wissenschaftler/-innen sichtbarer zu werden und sich einen Expertenstatus aufzubauen.</p><p>In Greifswald veranstaltet sie mehrmals im Jahr die Netzwerkveranstaltung PitchLab, in der Gründer/-innen und Unternehmer/-innen ihre Erfahrungen und Ideen austauschen. Ende 2019 veröffentlichte sie das Buch „Vertraute Feinde – Das Leben in der Politik“ im Selbstverlag und gibt gern ihre Erfahrungen und Tipps weiter.</p>',
          image: 'katja-wolter.jpg',
          link: 'https://www.steinbeis-inre.de'
        },
        {
          id: 'martin-horst',
          title: 'Martin Horst',
          text: '<p>Martin Horst liebt das, was er tut. Sein Beruf: Macher. Neben verschiedenen Firmen und Projekten möchte er mit seiner Partnerin Franzi und ihrer kleinen Eismanufaktur „Jackle & Heidi“ die Herzen der Kunden mit bestem Eis ohne Firlefanz zum Schmelzen bringen. Ihr Geheimrezept: ausgewählte Zutaten von bester Qualität, eine Prise Mut zum Außergewöhnlichen und eine große Portion Liebe – 100 % natürlich, 100 % handgemacht, 100 % lecker.</p>',
          image: 'martin-horst.jpg',
          link: 'https://www.jackle-heidi.com'
        },
        {
          id: 'rima-rifai',
          title: 'Rima Rifai',
          text: '<p>Bevor Rima ihre eigene Unternehmensgründung vorbereitete, war sie Teil eines mehrfach ausgezeichneten Gründerteams der Life Sciences aus der Leibniz Universität Hannover. Zusammen entwickelte das Team ein innovatives Medizinprodukt, das sie von Helsinki bis ins Silicon Valley vorstellten. Inspiriert durch ihre Mutter beschäftigte sich Rima zunehmend mit der neuronalen Wirkung von Düften, das auf große Nachfrage bei Unternehmen stieß. Sodass sie im Herbst 2018 mit ihrem Partner Benedikt Hirtahmmer die Duftmanufaktur ins Leben rief um Duftkonzepte für digitale Unternehmen zu entwickeln.</p>',
          image: 'rima-rifai.jpg',
          link: 'https://www.instagram.com/pyne_wellness/'
        },
        {
          id: 'maximilian-block',
          title: 'Maximilian Block',
          text: '<p>Maximilian Block ist der Gründer und Geschäftsführer der digitalen Rechtsberatung advocado. Sein 2014 in Greifswald gegründetes Startup gehört mittlerweile zu den führenden Legal-Tech-Unternehmen Deutschlands und wurde mehrfach ausgezeichnet. Das Konzept: Anwaltssuche erleichtern, Kosten transparent machen und schnelle, kompetente Hilfe für alle rechtlichen Angelegenheiten bieten. Dazu verbindet Maximilian Block mit advocado die Disziplinen Jura, BWL und IT.</p>',
          image: 'maximilian-block.jpg',
          link: 'https://www.advocado.de'
        }
      ]
    }
  }
}
</script>
